import { toggles } from '#features'
import { DevSettings } from '#settings/constants'
import { LegacyImport } from '#settings/dev.legacy'
import { LegacyAvlExternalImport } from '#settings/dev.legacy.avl.external'
import { LegacyAvlRavImport } from '#settings/dev.legacy.avl.rav'
import { useEnv } from 'apprise-frontend-core/env'
import { SettingRenderProps } from 'apprise-frontend-streams/settings/model'
import { ToggleSettingSection } from 'apprise-fullstack-core/toggle/toggle.settings.section'
import { ExplainerPanel } from 'apprise-ui/utils/explainer'
import { Fragment } from 'react'


// the toggle picker (apprise-fullstack-core, as dfad), then the legacy imports.
// beta testers see the panel in production too, for the picker: the imports write records, so they stay out there.
export const DevSettingsPanel = (props: SettingRenderProps<DevSettings>) => {

    const { settings, onChange } = props

    const env = useEnv()

    const style ={padding: "10px 20px", background: 'rgb(220 226 231)', marginBottom: 30, marginTop: 20, borderRadius: 4}


    return <ExplainerPanel style={{padding:20}} >

        <ToggleSettingSection features={toggles} value={settings.enabledFeatures ?? []}
            onChange={features => onChange({ ...settings, enabledFeatures: features })} />

        {env.name !== 'production' && <Fragment>

            <h2 style={style}>Import Vessels</h2>

            <LegacyImport />

            <br/>

            <h2 style={style}>Import AVL Declarations</h2>

            <LegacyAvlRavImport />

            <br/>

            <h2 style={style}>Import External AVL Declarations</h2>

            <LegacyAvlExternalImport />

        </Fragment>}

    </ExplainerPanel>

}
